<template>
	<div class="referred-table-container">
		<AppBottomSheet :forceWidth="bottomSheetWidth" :active="active" @togglingPopup="v => $emit('toggling-popup', v)">
<!--			<ModalHeader class="bottomsheet-header" :title="getString('invited_friends')" />-->
			<div class="col-12 table-wrapper">
				<AppTable
					:fetch-function="referralsStore.getFilteredReferralsRewards"
					:table-headings="tableHeadings"
					:items="referralsStore.referralsRewards || []"
					:total-items="referralsStore.totalReferralsRewards || 0"
					:title="getString('invited_friends')"
				>
					<template #booleanValue="field">
						<div class="col-12 centered">
							<div class="completed-icon" :class="{'success': field.item[field.heading.fieldName]}" :title="getString(field.item[field.heading.fieldName] ? 'completed' : 'pending')" v-html="field.item[field.heading.fieldName] ? getIcon('iconV') : getIcon('iconHourglass')"></div>
						</div>
					</template>
					<template #booleanValueTier="field">
						<div class="col-12 centered">
							<div class="completed-icon" :class="{'success': field.item[field.heading.fieldName]}" :title="getString(field.item[field.heading.fieldName] ? 'completed' : 'pending')" v-html="field.item[field.heading.fieldName] ? getIcon('iconV') : getIcon('iconHourglass')"></div>
						</div>
					</template>
				</AppTable>
			</div>
		</AppBottomSheet>
	</div>
</template>

<script>
import WindowWidth from "@/console-new/mixins/WindowWidth";
import AppBottomSheet from "@/shared/components/AppBottomSheet.vue";
import AppTable from "@/shared/components/AppTable.vue";
import AppButton from "@/shared/components/AppButton.vue";
import ModalHeader from "@/console-new/components/shared/ModalHeader.vue";
import {useLanguageStore, useSvgStore} from "@/shared/stores";
import {useReferralsStore} from "@/user/stores";

export default {
	setup() {
		const languageStore = useLanguageStore();
		const referralsStore = useReferralsStore();
		const getIcon = useSvgStore().get;
		return {getString: languageStore.getString, getIcon, referralsStore}
	},
	name: "ReferredUsersTable",
	components: {ModalHeader, AppButton, AppTable, AppBottomSheet},
	mixins: [WindowWidth],
	data() {
		return {
			loadingRewards: true,
			tableHeadings: [
				{
					text: this.getString('user_email'),
					cols: 2,
					fieldName: 'email',
				},
				{
					text: this.getString('business_name'),
					cols: 2,
					fieldName: 'name',
				},
				{
					text: this.getString('received'),
					cols: 1,
					fieldName: 'received',
					formatter: 'currency',
				},
				{
					text: this.getString('subscription'),
					cols: 1,
					fieldName: 'completed_subscription',
					slotName: 'booleanValue',
				},
				{
					text: this.getString('transactions_volume'),
					cols: 1,
					fieldName: 'completed_tier',
					slotName: 'booleanValueTier',
				}
			],
		}
	},
	props: {
		active: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		bottomSheetWidth() {
			if (this.windowWidth < 550) {
				return "100%";
			} else if (this.windowWidth < 1080) {
				return "90%";
			} else {
				return "920px";
			}
		},
	},
	methods: {
		fetchRewards() {
			this.referralsStore.getFilteredReferralsRewards({}, ()=>{
				this.loadingRewards = false;
			});
		},
	},
	mounted() {
		//this.fetchRewards();
	}
}
</script>

<style scoped lang="scss">
.bottomsheet-header {
	background-color: var(--color-alpha-2);
}
.table-wrapper {
	padding: 0 5px 7px 5px;
}
.completed-icon {
	:deep(svg) {
		height: 16px;
		width: 16px;

		.stroke {
			stroke: var(--color-warn);
		}
		.fill {
			fill: var(--color-warn);
		}
	}
	&.success {
		:deep(svg) {
			.stroke {
				stroke: var(--color-txt);
			}
			.fill {
				fill: var(--color-txt);
			}
		}
	}
}
</style>